import {PostOdontoRebookParams} from 'domain/usecases';
import {makePostOdontoRebook} from 'main/factories/usecases';

export async function postOdontoRebook(params: PostOdontoRebookParams) {
	const response = await makePostOdontoRebook().post(params);

	return response;
}
